'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { ourOpportunitiesTopics } from '@/app/(main)/(pages)/(institucional)/trabalhe-conosco/_consts/our-opportunities-topics.const';
import {
  CardInstitutional,
} from '@/app/(main)/(pages)/(institucional)/_components/card-institutional.component';
import { ContentContainer } from '@/components/ui/content-container.component';
import { Typography } from '@/components/ui/typography/typography.component';
import { TypographyVariant } from '@/components/ui/typography/typography.type';

export function OurOpportunities() {
  return (
    <>
      <div className="bg-green-50 border-green-100 border-2" id="our-opportunities">
        <ContentContainer>
          <Typography variant={TypographyVariant.MEDIUM_SUBTITLE} className="font-bold py-6 text-center lg:text-left">Nossas oportunidades</Typography>
        </ContentContainer>
      </div>
      <ContentContainer className="my-6 flex flex-col lg:flex-row gap-6 h-full" data-testid={DataTestIdEnum.WORK_WITH_US_CONTAINER_OUR_OPPORTUNITIES}>
        {ourOpportunitiesTopics.map((opportunity) => (
          <CardInstitutional
            key={`key-opportunity-${opportunity.title}`}
            {...opportunity}
          />
        ))}
      </ContentContainer>
    </>
  );
}
